import * as React from "react";
const SvgSwitchTableChecked = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={30} fill="none" {...props}>
    <rect width={39} height={24} x={1.5} y={3} fill="#826846" rx={12} />
  </svg>
);
export default SvgSwitchTableChecked;
